// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mQZu","top":"styles_top__3jhvi","left":"styles_left__10SjC","description":"styles_description__2UqAK"};